import { InlineText2 as Text } from '@cian/ui-kit';

import { clsx } from 'clsx';
import { FC, useMemo } from 'react';

import { IUnderground } from './types';
import { getIconTravel, getUndergroundIconBySubdomain } from './utils';

import * as styles from './styles.css';

export const Underground: FC<IUnderground> = props => {
  const { className, color, name, subdomain, travelTime, travelType } = props;

  const IconUnderground = useMemo(() => getUndergroundIconBySubdomain(subdomain), [subdomain]);
  const IconTravel = useMemo(() => getIconTravel(travelType), [travelType]);

  return (
    <div className={clsx(styles['root'], className)}>
      <span className={styles['item']}>
        <span className={clsx(styles['icon'], styles['underground'])} style={{ color: `#${color}` }}>
          <IconUnderground />
        </span>
        <Text>{name}</Text>
      </span>
      <span className={styles['item']}>
        <span className={styles['icon']}>
          <IconTravel />
        </span>
        <Text color="gray60_100">{`${travelTime} мин.`}</Text>
      </span>
    </div>
  );
};

Underground.displayName = 'Underground';
